function autoLoad( container: HTMLElement | Document ) {
    container.querySelectorAll<HTMLElement>( '[data-autoload-url]' ).forEach( async ( el: HTMLElement )=> {
        const loaded = !!el.dataset.autoloadLoaded;

        if ( loaded ) {
            return;
        }

        el.dataset.autoloadLoaded = 'true';

        const url = el.dataset.autoloadUrl;

        if ( !url ) {
            return;
        }

        let resetHeight = false;

        if ( el.dataset.resetHeight && el.dataset.resetHeight === 'true' ) {
            resetHeight = true;
        }

        const load = async () => {
            const response = await window.http( url );

            const html = await response.text();

            if ( html && html.length > 0 ) {
                el.innerHTML = html;
            }

            document.dispatchEvent( new CustomEvent( 'twc:newcontentloaded', {
                detail: {
                    container: el,
                },
                bubbles: true,
            } ) );

            if ( resetHeight ) {
                el.style[ 'min-height' ] = 'auto';
            }
        };

        const loadAsync = el.dataset.autoloadAsync && el.dataset.autoloadAsync === 'true';

        if ( loadAsync ) {
            const root = el.closest( '.pagepopup__scrollcontainer' ) || document;

            const onIntersect = async ( entries: IntersectionObserverEntry[] ) => {
                if ( entries.some( ( entry: IntersectionObserverEntry ) => entry.isIntersecting ) ) {
                    load();
                    observer.disconnect();
                }
            };

            const observer: IntersectionObserver = new IntersectionObserver( onIntersect, {
                root: root,
                rootMargin: '200px 0px 200px 0px',
            } );

            observer.observe( el );
        } else {
            load();
        }
    } );
}

export default autoLoad;
